export default __webpack_public_path__ + "static/media/GSKCH.62b8595e.png";